/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find how much time is between two dates — in days, weeks, months and weekdays — or count down to an upcoming date.`)
};

const es_dd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encuentra cuánto tiempo hay entre dos fechas — en días, semanas, meses y días de semana — o cuenta atrás hasta una próxima fecha.`)
};

const de_dd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finden Sie heraus, wie viel Zeit zwischen zwei Daten vergeht — in Tagen, Wochen, Monaten und Wochentagen — oder zählen Sie bis zu einem kommenden Datum.`)
};

const nl_dd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vind hoeveel tijd er tussen twee datums zit — in dagen, weken, maanden en weekdagen — of tel af tot een komende datum.`)
};

const fr_dd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trouvez le temps écoulé entre deux dates — en jours, semaines, mois et jours de la semaine — ou comptez à rebours jusqu'à une date à venir.`)
};

const it_dd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri quanto tempo c'è tra due date — in giorni, settimane, mesi e giorni feriali — o fai il conto alla rovescia fino a una data imminente.`)
};

const pt_br2_dd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubra quanto tempo existe entre duas datas — em dias, semanas, meses e dias úteis — ou faça uma contagem regressiva para uma data futura.`)
};

const pt_dd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubra quanto tempo há entre duas datas — em dias, semanas, meses e dias da semana — ou faça uma contagem regressiva até uma data futura.`)
};

const ja_dd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2つの日付間にどのくらいの時間があるかを見つけてください — 日数、週、月、平日で — または今後の日付までカウントダウンしてください。`)
};

const zh_dd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算两个日期之间的时间长度——以天、周、月和工作日为单位——或为即将到来的日期设置倒计时。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dd_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dd_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dd_intro", locale)
	if (locale === "en") return en_dd_intro(inputs)
	if (locale === "es") return es_dd_intro(inputs)
	if (locale === "de") return de_dd_intro(inputs)
	if (locale === "nl") return nl_dd_intro(inputs)
	if (locale === "fr") return fr_dd_intro(inputs)
	if (locale === "it") return it_dd_intro(inputs)
	if (locale === "pt-BR") return pt_br2_dd_intro(inputs)
	if (locale === "pt") return pt_dd_intro(inputs)
	if (locale === "ja") return ja_dd_intro(inputs)
	return zh_dd_intro(inputs)
};